<template>
  <Card>
    <search></search>
    <workSheetTable ref="workSheetTableRef" :tableColumns="tableColumns" :status="status"></workSheetTable>
  </Card>
</template>

<script>
import search from './components/search'
import workSheetTable from './components/workSheetTable'
import moment from 'moment'
import { OpenApi } from '../../api/logistics/worksheet'

export default {
  name: 'closed',
  components: {
    'search': search,
    'workSheetTable': workSheetTable
  },
  data () {
    return {
      status: [0],
      tableColumns: [
        {
          title: '工单编号',
          align: 'center',
          width: 200,
          key: 'wsid'
        },
        {
          title: '提交人',
          align: 'center',
          width: 150,
          key: 'submitter'
        },
        {
          title: '标题',
          align: 'center',
          width: 250,
          key: 'title'
        },
        {
          title: '工单类型',
          align: 'center',
          width: 160,
          key: 'type',
          render: (h, params) => {
            let result = ''
            if (params.row.type) {
              result = params.row.type.type_name
            }
            return h('span', result)
          }
        },
        {
          title: '提交时间',
          align: 'center',
          width: 160,
          key: 'c_time',
          render: (h, params) => {
            if (params.row.c_time) {
              return h('div', moment(params.row.c_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '受理人',
          align: 'center',
          width: 100,
          key: 'receive_people_name'
        },
        {
          title: '受理时间',
          align: 'center',
          width: 160,
          key: 'a_time',
          render: (h, params) => {
            if (params.row.a_time) {
              return h('div', moment(params.row.a_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '处理人',
          align: 'center',
          width: 100,
          key: 'operator_name'
        },
        {
          title: '处理时间',
          align: 'center',
          width: 160,
          key: 'f_time',
          render: (h, params) => {
            if (params.row.f_time) {
              return h('div', moment(params.row.f_time).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', '已关闭')
          }
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$refs.workSheetTableRef.detail(params.row.id)
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                attrs: {
                  disabled: params.row.source === '在线客服'
                },
                on: {
                  click: () => {
                    this.open(params.row.id)
                  }
                }
              }, '打开')
            ])
          }
        }
      ]
    }
  },
  methods: {
    open (id) {
      this.$Modal.confirm({
        title: '打开工单',
        content: '<p>打开后工单返回到「处理中」状态，确定要打开该工单吗？</p>',
        onOk: () => {
          OpenApi({ id: id }).then(res => {
            let result = res.data
            if (result.code === 200) {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.$refs.workSheetTableRef.init()
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: result.msg
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
